import { useEffect, useState, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { resolveMedia } from "@/lib/api";

/** Lightbox condivisa: ingrandimento e scorrimento immagini, desktop + swipe mobile. */
export function Lightbox({ images, index, onClose, onNavigate }) {
  const [touchX, setTouchX] = useState(null);
  const total = images.length;
  const cur = images[index];

  const prev = useCallback(() => onNavigate((index - 1 + total) % total), [index, total, onNavigate]);
  const next = useCallback(() => onNavigate((index + 1) % total), [index, total, onNavigate]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [onClose, prev, next]);

  if (!cur) return null;
  return (
    <div className="fixed inset-0 z-[90] bg-ink/95 flex flex-col" onClick={onClose} data-testid="lightbox" role="dialog" aria-label="Galleria immagini">
      <button onClick={onClose} className="absolute top-4 right-4 z-10 bg-bone/10 text-bone p-3 hover:bg-gold hover:text-ink transition-colors" data-testid="lightbox-close" aria-label="Chiudi">
        <X size={20} />
      </button>
      <div className="flex-1 flex items-center justify-center p-4 md:p-10 min-h-0"
        onClick={(e) => e.stopPropagation()}
        onTouchStart={(e) => setTouchX(e.touches[0].clientX)}
        onTouchEnd={(e) => {
          if (touchX === null) return;
          const dx = e.changedTouches[0].clientX - touchX;
          if (Math.abs(dx) > 50) (dx > 0 ? prev : next)();
          setTouchX(null);
        }}>
        <img src={resolveMedia(cur.url)} alt={cur.alt || ""}
          className="max-w-full max-h-full object-contain select-none" data-testid="lightbox-image" draggable={false} />
      </div>
      <div className="flex items-center justify-between px-4 md:px-10 pb-6 text-bone" onClick={(e) => e.stopPropagation()}>
        <button onClick={prev} className="p-3 min-w-[44px] min-h-[44px] bg-bone/10 hover:bg-gold hover:text-ink transition-colors" data-testid="lightbox-prev" aria-label="Precedente"><ChevronLeft size={20} /></button>
        <div className="text-center min-w-0 px-4">
          {cur.caption && <p className="text-sm text-bone/90 font-light truncate">{cur.caption}</p>}
          <p className="text-[11px] tracking-[0.14em] uppercase text-bone/60 mt-1">{index + 1} / {total}</p>
        </div>
        <button onClick={next} className="p-3 min-w-[44px] min-h-[44px] bg-bone/10 hover:bg-gold hover:text-ink transition-colors" data-testid="lightbox-next" aria-label="Successiva"><ChevronRight size={20} /></button>
      </div>
    </div>
  );
}
